export var createAudioParamRenderer = function createAudioParamRenderer() {
  var automations = [];
  return {
    record: function record(automation) {
      automations.push(automation);
    },
    replay: function replay(audioParam) {
      for (var _i = 0, _automations = automations; _i < _automations.length; _i++) {
        var automation = _automations[_i];

        if (automation.type === 'cancelScheduledValues') {
          var cancelTime = automation.cancelTime;
          audioParam.cancelScheduledValues(cancelTime);
        } else if (automation.type === 'exponentialRampToValue') {
          var endTime = automation.endTime,
              value = automation.value;
          audioParam.exponentialRampToValueAtTime(value, endTime);
        } else if (automation.type === 'linearRampToValue') {
          var _endTime = automation.endTime,
              _value = automation.value;
          audioParam.linearRampToValueAtTime(_value, _endTime);
        } else if (automation.type === 'setTarget') {
          var startTime = automation.startTime,
              target = automation.target,
              timeConstant = automation.timeConstant;
          audioParam.setTargetAtTime(target, startTime, timeConstant);
        } else if (automation.type === 'setValue') {
          var _startTime = automation.startTime,
              _value2 = automation.value;
          audioParam.setValueAtTime(_value2, _startTime);
        } else if (automation.type === 'setValueCurve') {
          var duration = automation.duration,
              _startTime2 = automation.startTime,
              values = automation.values;
          audioParam.setValueCurveAtTime(values, _startTime2, duration);
        } else {
          throw new Error("Can't apply an unknown automation.");
        }
      }
    }
  };
};